import { render } from "./VersionAddComponent.vue?vue&type=template&id=b4a4669e&scoped=true"
import script from "./VersionAddComponent.vue?vue&type=script&lang=js"
export * from "./VersionAddComponent.vue?vue&type=script&lang=js"

import "./VersionAddComponent.vue?vue&type=style&index=0&id=b4a4669e&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a4669e"]])

export default __exports__